import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    pin: {
      marginLeft: 6,
    },
    content: {
      marginTop: 16,
      marginBottom: 52,
    },
  });
